import Header from "src/Component/content-component/Header";
import ParaData from "src/Component/content-component/ParaData";
import ContentContainer from "src/Component/grid-component/ContentContainer";
import ImageContainer from "src/Component/grid-component/ImageContainer";
import MainContainer from "src/Component/grid-component/MainContainer";

//const mbbsImgDelhi = imageBaseUrl + "mbbsinindia.png";
const mbbsImgDelhi = "https://i.pinimg.com/736x/4e/9b/ac/4e9baccc4cb397bb2a3ee42cfcd887a8.jpg";

const DelhiNCRAdvantage = () => {
  return (
    <>
      <MainContainer
        dir="column-reverse"
        color={"#EFFDFF"}
        com1={<ImageContainer img={mbbsImgDelhi} alt="MBBS Abroad Consultants In Delhi NCR" />}
        com2={
          <ContentContainer
            Header={<Header content={"The Delhi NCR Advantage"} />}
            Content={
              <ParaData
                color={"#525560"}
                fontSize={"16px"}
                content={
                  "Delhi NCR is a growing city with great schools, colleges, and a bright student community. It is a place full of opportunities for students who dream big! As expert study abroad consultants in Delhi NCR, we help students like you find the best universities, scholarships, and admission opportunities in different countries.If you want to study abroad but don’t know how to start, don’t worry! We are here to guide you at every step and make your journey smooth and easy."
                }
              />
            }
            
          />
        }
      />
    </>
  );
};
export default DelhiNCRAdvantage;
